import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { logout } from "../auth/helper";

export const SessionTimeout = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  let title = "";
  let text = "";

  // @ts-ignore
  const errorCode: number = 401;
  switch (errorCode) {
    case 401:
      title = "Session Timeout";
      text =
        "You have exceeded the inactivity limit for the application. Please\n" +
        "return to the login page and login to access the application.";
      break;
    default:
      title = "Unknown Error";
      text = "The application failed to handle your request.";
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={true}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => logout(dispatch)}>Continue</Button>
      </DialogActions>
    </Dialog>
  );
};
